import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../config';

/**
 * Analytics component — chargement conditionnel GA4 ou Plausible
 * Ne se charge QUE si l'utilisateur a accepté les cookies
 * Tracke automatiquement les changements de page via React Router
 */
const Analytics = () => {
  const location = useLocation();

  // Injection du script Analytics si consentement donné
  useEffect(() => {
    const consent = localStorage.getItem('aid_cookie_consent');
    if (consent !== 'accepted') return;

    // Option 1 : Plausible (si REACT_APP_PLAUSIBLE_DOMAIN défini)
    if (config.plausibleDomain && !document.getElementById('plausible-script')) {
      const script = document.createElement('script');
      script.id = 'plausible-script';
      script.defer = true;
      script.dataset.domain = config.plausibleDomain;
      script.src = 'https://plausible.io/js/script.js';
      document.head.appendChild(script);
    }

    // Option 2 : Google Analytics 4 (si REACT_APP_GA_ID défini)
    if (config.gaId && !document.getElementById('ga4-script')) {
      const script = document.createElement('script');
      script.id = 'ga4-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${config.gaId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', config.gaId, { anonymize_ip: true });
    }
  }, []);

  // Track pageview à chaque changement de route
  useEffect(() => {
    const consent = localStorage.getItem('aid_cookie_consent');
    if (consent !== 'accepted') return;

    // Plausible
    if (window.plausible) {
      window.plausible('pageview');
    }

    // GA4
    if (window.gtag && config.gaId) {
      window.gtag('config', config.gaId, {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  return null;
};

export default Analytics;
